import React, { useState } from "react";
import { useFeaturePage } from "./hook";
import { MainTemplate } from "../../templates/MainTemplate";
import { TableTemplate } from "../../templates/TableTemplate";
import { CreateFeatureModal } from "../../organisms/modal/CreateFeatureModal";
import { Feature } from "../../../ducks/feature";
import { EditFeatureModal } from "../../organisms/modal/EditFeatureModal";
import { Resource, Permission } from "../../../constants/permissions";
import { useFeatureToast } from "./hook";
import styled from "styled-components";
import { useResponsive } from "../../../hooks/useResponsive";

export const FeaturePage = () => {
  const { showToast } = useFeatureToast();
  const { isMobile } = useResponsive();
  const {
    tableHeaders,
    features,
    handleRowDelete,
    handleCloseCreateModal,
    handleOpenCreateModal,
    handleCloseEditModal,
    handleOpenEditModal,
    isCreateModalOpen,
    isEditModalOpen,
    refetchFeatures,
  } = useFeaturePage();

  const [selectedFeature, setSelectedFeature] = useState<Feature | null>(null);
  return (
    <>
      <MainTemplate
        title="Features"
        useFitHeight
        button={{
          text: "Create",
          variant: "filled",
          onClick: handleOpenCreateModal,
          permission: {
            resource: Resource.FEATURES,
            permission: Permission.CREATE,
          },
        }}
      >
        <StyledTableWrapper $isMobile={isMobile}>
          <TableTemplate<Feature>
            headers={tableHeaders}
            data={features}
            fetchDataFunction={() => { }}
            columnWidths={["10%", "30%", "30%", "30%"]} // No: 10%, Name: 30%, KH: 30%, ZH: 30%
            editable
            deletable
            showHeaderDeleteIcon={false}
            resource={Resource.FEATURES}
            onPermissionError={showToast}
            onDelete={handleRowDelete}
            onEdit={(feature) => {
              setSelectedFeature(feature);
              handleOpenEditModal();
            }}
            stickyHeader
            hasPagination={false}
          />
        </StyledTableWrapper>
      </MainTemplate>
      <CreateFeatureModal
        isOpen={isCreateModalOpen}
        onClose={handleCloseCreateModal}
        refetchFeatures={refetchFeatures}
      />
      {selectedFeature && (
        <EditFeatureModal
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          defaultValues={{
            name: selectedFeature.name,
            name_kh: selectedFeature.name_kh,
            name_zh: selectedFeature.name_zh,
          }}
          featureId={selectedFeature.id}
          refetchFeatures={refetchFeatures}
        />
      )}

    </>
  );
};

const StyledTableWrapper = styled.div<{ $isMobile?: boolean }>`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  
  ${({ $isMobile }) =>
    $isMobile
      ? `
      -webkit-overflow-scrolling: touch;
      max-height: calc(100vh - 200px);
      `
      : `
      max-height: calc(100vh - 250px);
      `}
`;
